import { Injectable, NgZone } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of, throwError,EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { EndPointsEnum } from 'src/app/shared/enums/end-points';
import { RouterEnum } from 'src/app/shared/enums/router.enum';
import { AuthService } from '../services/auth.service';
import { UiUtilityService } from '../services/ui-utility.service';
import { errorMessage } from './error-message';
import { ERROR_CODES } from 'src/app/shared/config/app.constant';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  // private readonly DEFAULT_TIMEOUT = 20000;

  constructor(
    private authService: AuthService,
    private uiUtilityService: UiUtilityService,
    private route: Router,
    private ngZone: NgZone
  ) { }
private is401AlertShowing = false;
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> {
    return next.handle(request).pipe(
      tap((event: any) => {
        if (event instanceof HttpResponse) {
          if (event.body?.errorCode === ERROR_CODES.PCC_OFF) {
            const buttons = [
              {
                text: 'Return to Sign In',
                handler: () => {
                  this.authService.clearStorage();
                  this.ngZone.run(() => {
                    this.uiUtilityService.closeModal();
                    this.route.navigate([RouterEnum.login], { replaceUrl: true });
                  });
                },
              },
            ];
            this.uiUtilityService.showAlert(event.body?.errorMessage, 'Alert', buttons);
          }
        }
      }),
      catchError((err: HttpErrorResponse) => {
        this.uiUtilityService.closeLoader();
        if (
          err instanceof HttpErrorResponse &&
          !request.url.includes(EndPointsEnum.logout)
        ) {
          switch (err.status) {
        case 401:
  // Prevent duplicate alert triggers if multiple 401s arrive at once
  if (this.is401AlertShowing) {
    return EMPTY;
  }
  this.is401AlertShowing = true;

  if (this.authService.isUserLoggedIn) {
    this.authService.didLogout();
  }
  this.authService.clearStorage();

  this.ngZone.run(() => {
    this.uiUtilityService.closeModal();

    const buttons = [
      {
        text: 'Ok',
        handler: () => {
          this.is401AlertShowing = false;
          this.route.navigate([RouterEnum.login], { replaceUrl: true });
        },
      },
    ];

    this.uiUtilityService.showAlert(
      'For your security, please sign back in to continue.',
      '',
      buttons
    );
  });

  return EMPTY;
  // (No break here)    
	case 404:
              if (this.authService.isUserLoggedIn) {
                this.ngZone.run(() => {
                  this.route.navigate([RouterEnum.dashboard]);
                });
              }
              break;
            case 423:
              // forbidden access handling
              return throwError(err);
            default:
              if (!navigator.onLine) {
                this.uiUtilityService.showAlert(errorMessage.noNetwork, 'Alert');
                return of();
              }
              return throwError(err);
          }
        }
        return throwError(err);
      })
    );
  }
}
